import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material.module';
import { CoreService } from 'src/app/services/core.service';
import { TablerIconsModule } from 'angular-tabler-icons';

@Component({
    selector: 'app-dark-mode-dropdown',
    imports: [MaterialModule, TranslateModule, TablerIconsModule],
    templateUrl: './dark-mode-dropdown.component.html',
    styleUrl: './dark-mode-dropdown.component.scss'
})
export class DarkModeDropdownComponent implements OnInit {
  private htmlElement!: HTMLHtmlElement;
  selectedTheme: any;

  constructor(
    public dialog: MatDialog,
    private coreService: CoreService) {
    this.htmlElement = document.querySelector('html')!;
  }
  
  ngOnInit() {
    this.selectedTheme = this.coreService.getTheme() === 'sun-high' ? 'sun-high' : 'moon';
    this.coreService.setTheme(this.selectedTheme);
    this.changeClassTheme(this.selectedTheme);
  }

  changeTheme() {
    this.selectedTheme = this.selectedTheme === 'sun-high' ? 'moon' : 'sun-high';
    this.coreService.setTheme(this.selectedTheme);
    this.changeClassTheme(this.selectedTheme);
  }

  changeClassTheme(theme: string) {
    this.htmlElement.classList.toggle('dark-theme', theme === 'sun-high');
    this.htmlElement.classList.toggle('light-theme', theme === 'moon');
  }
}
